// @flow
import React from "react";
import cx from "classnames";
import glamorous from "glamorous";
import ResultsTopBar from "root/components/ResultsTopBar";
import NoResults from "../NoResults";
import VirtualResultsGrid from "./VirtualResultsGrid/VirtualResultsGrid";

type propsType = {
    images: Object[],
    selected?: string[],
	allowSelect?: boolean,
    isMultiple?: boolean,
    selectionAction?: Function,
	onLoadMore?: Function,
    showProgressIndicator?: boolean,
    useImageClientSize?: boolean,
    topBarRenderer?: Function,
    topBarClassName?: string,
    alwaysShowPreviewInfo?: boolean,
    customTilePreviewInfo?: React$Node,
	hasMore?: boolean;
	isLoading?: number;
	itemWidth? :number;
};

const GGridTopBar = glamorous.div("pa5");

const ResultImageGrid = (props: propsType) => {

	const renderGridContent = () => (props.images?.length || props.showProgressIndicator
		? <VirtualResultsGrid
				images={props.images}
				selected={props.selected}
				selectionAction={props.selectionAction}
				onLoadMore={props.onLoadMore}
				useImageClientSize={props.useImageClientSize}
				isMultiple={props.isMultiple}
				allowSelect={props.allowSelect}
				customPreviewInfo={props.customTilePreviewInfo}
				alwaysShowPreviewInfo={props.alwaysShowPreviewInfo}
				hasMore={props.hasMore}
				itemWidth={props.itemWidth}
				isLoading={props.showProgressIndicator}
			/>
		: (!props.showProgressIndicator && <NoResults key="ig_no_results"/>));

	const topBarRenderResult = props.topBarRenderer?.();

	return <div className="relative flex flex-column justify-center h-100" data-test="grid-container">
		{topBarRenderResult &&
			<ResultsTopBar>
				<GGridTopBar className={props.topBarClassName} data-test="grid-top-bar">
					{topBarRenderResult}
				</GGridTopBar>
			</ResultsTopBar>
		}

		<div className={cx("grid scroller flex-grow-1", { empty: props.images.length })}>
			{renderGridContent()}
		</div>
	</div>;
};

ResultImageGrid.defaultProps = {
	allowSelect: true,
	showProgressIndicator: false,
	useImageClientSize: false,
};

export default ResultImageGrid;
